export default {
  sm: `
  Our data
  protected by our
  own technology
  `,
  md: `
  Our data protected by
  our own technology
  `
};
